import C from "../../common/constantes"
import Sales from '../../../services/sales'
import messageDialog from '../../../components/message-dialog.vue';
import {EventBus} from '../../../event-bus'


export default {
  props: ['type', 'rodosol'],
  data() {
    return {
      loading: undefined,
    }
  },


  computed:{
    sameTax(){
      return this.newAhesionTaxMan == this.newVehicleTaxMan && this.newAhesionTaxAut == this.newVehicleTaxAut
    },
    newAhesionTaxMan(){
      return this.$store.getters.getNewAdhesionTax(C.PLAN_MAN_PJ);
    },
    newVehicleTaxMan(){
      return this.$store.getters.getNewVehicleTax(C.PLAN_MAN_PJ);
    },
    newAhesionTaxAut(){
      return this.$store.getters.getNewAdhesionTax(C.PLAN_AUT_PJ);
    },
    newVehicleTaxAut(){
      return this.$store.getters.getNewVehicleTax(C.PLAN_AUT_PJ);
    },
    newVehicleTaxPos(){
      return this.$store.getters.getNewVehicleTax(C.PLAN_POS);
    },
    newAhesionTaxPos(){
      return this.$store.getters.getNewAdhesionTax(C.PLAN_POS);
    },
    newAhesionTaxPreMen(){
      return this.$store.getters.getNewAdhesionTax(C.PLAN_PREMEN_PJ);
    },
    newVehicleTaxPreMen(){
      return this.$store.getters.getNewVehicleTax(C.PLAN_PREMEN_PJ);
    }

  },

  methods:{
    choose(planId){
      if(this.type=='newContract') {
        EventBus.$emit('chooseNewPlan', planId);
      } else if(this.type=='migration') {
        EventBus.$emit('migrationPlan', planId);
      } else {
        this.$router.push({'name': 'adhesion', 'query':{'planId': planId}});
      }
    },
    // choose(planId){
    //   if(this.type=='newContract'){
    //     EventBus.$emit('chooseNewPlan', planId);
    //   } else {
    //     this.$router.push({'name': 'adhesion', 'query':{'planId': planId}});
    //   }
    // },

  }
}



// WEBPACK FOOTER //
// ./src/pages/external/plans/b2b.js